import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkTableModule } from '@angular/cdk/table';
import { CustomMatPaginatorIntl } from './mat-paginator-intl.override';
import { MatBadgeModule } from '@angular/material/badge';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { GlmInputComponent } from './glm-input/glm-input.component';
import { GlmCheckboxComponent } from './glm-checkbox/glm-checkbox.component';
import { GlmTextboxComponent } from './glm-textbox/glm-textbox.component';
import { GlmRadioComponent } from './glm-radio/glm-radio.component';
import { GlmInputFileComponent } from './glm-input-file/glm-input-file.component';
import { GlmDropdownComponent } from './glm-dropdown/glm-dropdown.component';
import { GlmCheckComponent } from './glm-checkbox/glm-check/glm-check.component';
import { GlmResourceUploadModule } from '../glm-resource-upload/glm-resource-upload.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GlmLongtextboxComponent } from './glm-longtextbox/glm-longtextbox.component';
import { GlmDateComponent } from './glm-date/glm-date.component';
import { CustomDatepickerComponent } from './custom-datepicker/custom-datepicker.component';
import { ImageErrorDirective } from 'src/app/_directives/ui-image-error.directive';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatSelectModule,
    MatToolbarModule,
    MatMenuModule,
    MatCheckboxModule,
    MatChipsModule,
    MatInputModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatIconModule,
    MatTabsModule,
    MatExpansionModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDialogModule,
    CdkTableModule,
    MatDividerModule,
    MatStepperModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatListModule,
    MatCardModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatRadioModule,
    GlmResourceUploadModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    ImageErrorDirective,
  ],
  exports: [
    MatButtonModule,
    MatSelectModule,
    MatToolbarModule,
    MatMenuModule,
    MatCheckboxModule,
    MatChipsModule,
    MatInputModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatIconModule,
    MatTabsModule,
    MatExpansionModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDialogModule,
    CdkTableModule,
    MatDividerModule,
    MatStepperModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatListModule,
    MatCardModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatRadioModule,
    GlmInputComponent,
    GlmCheckboxComponent,
    GlmTextboxComponent,
    GlmRadioComponent,
    GlmInputFileComponent,
    GlmDropdownComponent,
    GlmCheckComponent,
    CustomDatepickerComponent,
    
    
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  declarations: [
    GlmInputComponent,
    GlmCheckboxComponent,
    GlmTextboxComponent,
    GlmRadioComponent,
    GlmInputFileComponent,
    GlmDropdownComponent,
    GlmCheckComponent,
    GlmLongtextboxComponent,
    GlmDateComponent,
    CustomDatepickerComponent,
  ],
})
export class GLMMaterialDesignModule {}